// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../rescript/lib/es6/curry.js";
import * as Generic$ApiTypes from "./utils/Generic.bs.js";

function size_encode(t) {
  if (t) {
    return Generic$ApiTypes.Encode.deccoVariantWithPayload(t._0, "Int", Generic$ApiTypes.Encode.$$int);
  } else {
    return Generic$ApiTypes.Encode.simpleVariant([[
                  "Auto",
                  /* Auto */0
                ]], t);
  }
}

var size_decode = Curry._2(Generic$ApiTypes.Decode.oneOf, Generic$ApiTypes.Decode.deccoVariantWithPayload("Int", Generic$ApiTypes.Decode.$$int, (function (i) {
            return /* Int */{
                    _0: i
                  };
          })), [Generic$ApiTypes.Decode.simpleVariant([[
              "Auto",
              /* Auto */0
            ]])]);

function t_encode(t) {
  return Curry._1(Generic$ApiTypes.Encode.object, [
              [
                "code",
                Curry._1(Generic$ApiTypes.Encode.string, t.code)
              ],
              [
                "size",
                Curry._2(Generic$ApiTypes.Encode.array, [
                      t.size[0],
                      t.size[1]
                    ], size_encode)
              ]
            ]);
}

var t_decode = Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._1(Generic$ApiTypes.Decode.succeed, (function (code, size) {
                return {
                        code: code,
                        size: size
                      };
              })), Curry._2(Generic$ApiTypes.Decode.field, "code", Generic$ApiTypes.Decode.string)), Curry._2(Generic$ApiTypes.Decode.field, "size", Curry._2(Generic$ApiTypes.Decode.tuple2, size_decode, size_decode)));

export {
  size_encode ,
  size_decode ,
  t_encode ,
  t_decode ,
}
/* size_decode Not a pure module */
